<p-toast></p-toast>

<!-- Show loading while checking LPR status -->
<div *ngIf="isCheckingLPRStatus" class="flex align-items-center justify-content-center p-5">
    <p-progressSpinner></p-progressSpinner>
</div>

<!-- Show message if LPR is not active -->
<div *ngIf="!isCheckingLPRStatus && !isLPRActive" class="surface-section px-4 py-5 md:px-6 lg:px-8 text-center">
    <div class="mb-3">
        <i class="pi pi-info-circle text-6xl text-orange-500"></i>
    </div>
    <div class="text-900 text-2xl font-bold mb-3">LPR Billing is not active on the portal</div>
    <div class="text-700 text-lg mb-5">
        Please use the old attendant portal to view tenants for this location.
    </div>
    <a [href]="siteUrl" class="p-button p-component">
        <span class="p-button-label">Go to Old Portal</span>
    </a>
</div>

<!-- Show normal content only if LPR is active -->
<div *ngIf="!isCheckingLPRStatus && isLPRActive">
<div class="grid p-fluid">
  <div class="col-12">
    <div class="card">
     <p-toolbar>
          <div class="p-toolbar-group-center">
              <h3 class="m-0">Tenants - {{ locationId }}</h3>
          </div>
      </p-toolbar>
      <p-table #tenantTable [value]= "tenants"
               [globalFilterFields]="['tid', 'suite', 'account', 'name', 'billto', 'street_address','city', 'state', 'zip', 'email']"
               [resizableColumns]="true" responsiveLayout="scroll" [paginator]="true" [rows]="10" [rowHover]="true"
               [totalRecords]="totalTenants" [loading]="isTenantlistLoading" [lazy]="false" sortField="billto" [sortOrder]="1">
        <ng-template pTemplate="caption">
          <div class="flex align-items-center justify-content-between">
            <div></div>
            <div class="col-3">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                       (input)="tenantTable.filterGlobal($any($event.target).value, 'contains')"
                                       placeholder="Search..." />
                            </span>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="color: darkred" pResizableColumn pSortableColumn="account">
              Account
              <p-sortIcon field="account"></p-sortIcon>
            </th>
            <th style="color: darkred" pResizableColumn pSortableColumn="billStatus">
              Bill
              <p-sortIcon field="billStatus"></p-sortIcon>
            </th>
            <th style="color: darkred" pResizableColumn pSortableColumn="billto">
              Name
              <p-sortIcon field="billto"></p-sortIcon>
            </th>
            <th style="color: darkred" pResizableColumn pSortableColumn="name">
              Bill To Contact
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="street_address">
              Street Address
              <p-sortIcon field="street_address"></p-sortIcon>
            </th>
            <th style="color: darkred" pResizableColumn pSortableColumn="city">
              City
              <p-sortIcon field="city"></p-sortIcon>
            </th>
            <th style="color: darkred" pResizableColumn pSortableColumn="state">
              State
              <p-sortIcon field="state"></p-sortIcon>
            </th>
            <th style="color: darkred" pResizableColumn pSortableColumn="zip">
              Zip Code
              <p-sortIcon field="zip"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="email">
              Email/Phone x Ext
              <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th pResizableColumn ="Update">
              Update
            </th>
            <th pResizableColumn ="Invoice">
              Invoice
            </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tenant>
          <tr>
            <td class="mpi-text-truncate">
              {{ tenant.suite }}-{{ tenant.account }}
              <br />
              <p-button (onClick)="tenant.pendingHide == 'show' || tenant.pendingHide == '' || tenant.pendingHide == 'active' ?  op.toggle($event) : updateTenantStatus(tenant.pendingHide, tenant.suite, tenant.account) " styleClass="text-left px-0 mx-0" [text]="true" label="{{ tenant.pendingHide == 'show' || tenant.pendingHide == '' ? 'active' : tenant.pendingHide }}">
                <p-overlayPanel #op appendTo="body" showCloseIcon="true">
                  <div class="flex flex-column gap-2">
                    <label for="reason" class="label-required">Why is this tenant status changing?</label>
                    <input pInputText  id="reason" #reason />
                  </div>
                  <div class="w-full text-right p-2" >
                    <p-button label="Save" [disabled]="!reason.value" (onClick)="updateTenantStatus(tenant.pendingHide, tenant.suite, tenant.account, reason.value)"/>
                  </div>
                </p-overlayPanel>
                </p-button>
            </td>
            <td class="mpi-text-truncate pl-0">
              <p-button icon="pi pi-dollar"[text]="true" severity="success" *ngIf="tenant.billStatus == 'send'"/>
              <p-button icon="pi pi-dollar"[text]="true" disabled *ngIf="tenant.billStatus == 'hold'"/>
            </td>
            <td class="mpi-text-truncate" style="text-wrap: auto;max-width: 200px;">{{ tenant.billto }}</td>
            <td class="mpi-text-truncate">{{ tenant.name }}</td>
            <td class="mpi-text-truncate" style="text-wrap: auto;max-width: 200px;">{{ tenant.street_address }}</td>
            <td class="mpi-text-truncate">{{ tenant.city }}</td>
            <td class="mpi-text-truncate">{{ tenant.state }}</td>
            <td class="mpi-text-truncate">{{ tenant.zip }}</td>
            <td class="mpi-text-truncate" [innerHTML]="tenant.email" style="text-wrap: auto;max-width: 200px;"></td>

            <!-- TODO: update with actual functionality (update, invoice) -->
            <td>
              <!-- <a *ngIf="env.buildMode === 'serve'" pButton [routerLink]="['/invoice/99999/'+tenant.suite+'/'+tenant.account]" icon="pi pi-pencil" iconPos="right"></a> -->

                <a pButton [href]="'/portal/apps/tenant/update/'+tenant.suite+'/'+tenant.account" class="no-underline" icon="pi pi-pencil" iconPos="right"></a>
            </td>
            <td>
              <!-- TODO change to a router link for the update due to stale page issues. -->
                <!-- <a *ngIf="env.buildMode === 'serve'" pButton [routerLink]="['/invoice/99999/'+tenant.suite+'/'+tenant.account]" icon="pi pi-file-o" iconPos="right"></a> -->

               <a pButton [routerLink]="'/portal/apps/tenant/update/'+tenant.suite+'/'+tenant.account" class="no-underline" icon="pi pi-file-o" iconPos="right"></a>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
              <td colspan="10" class="text-center"><b>No Data Found.</b></td>
          </tr>
      </ng-template>
      </p-table>
    </div>
  </div>
</div>
</div> <!-- End of LPR active content wrapper -->
